
import { RouteContextType } from "../../hooks/use-route-context/UseRouteContext";

export const keys = {
    all: ["custom-form-templates"],
    data: (
        customerID:  number,
        routeContext: RouteContextType,
        offlineDataLoaded: boolean,        
        offline: boolean,
        
) => [
        ...keys.all,
        "data", {
            customerID,
            routeContext,
            offlineDataLoaded,
            offline
        }
    ],
};
